import { yesNo } from './fields';

const COUNT_OPTIONS = Array.from({ length: 11 }, (_, count) => ({
  text: String(count),
  value: String(count),
}));

const COUNT_FIELDS = [
  ['anticipateChangeHouseholdPregnancy', 'Pregnancy?'],
  ['anticipateChangeHouseholdAdoption', 'Adoption?'],
  ['anticipateChangeHouseholdFoster', 'Foster Child(ren)?'],
];

// The counts only apply while the answer is not "no".
const count = (name, label, isLocked) => ({
  variant: 'singleSelect',
  name,
  label,
  options: COUNT_OPTIONS,
  watchFields: ['anticipateChangeHousehold'],
  disabled: ({ getValues }) =>
    isLocked || getValues('anticipateChangeHousehold') === 'no',
  GridProps: { xs: 12, sm: 3 },
});

const buildHouseholdInformation = ({ isLocked }) => ({
  name: 'householdInformation',
  title: 'HOUSEHOLD INFORMATION',
  titleVariant: 'subsection',
  divider: true,
  container: 'default',
  disabled: isLocked,
  fields: [
    {
      ...yesNo(
        'anticipateChangeHousehold',
        'Do you anticipate having a change in household occupants in the next 12 months? ' +
          'If "yes", how many additional occupants are expected due to:',
      ),
      changeActions: COUNT_FIELDS.map(([target]) => ({
        type: 'updateField',
        target,
        value: '0',
        when: { eq: 'no' },
      })),
    },
    ...COUNT_FIELDS.map(([name, label]) => count(name, label, isLocked)),
  ],
});

export default buildHouseholdInformation;
